module.exports = __webpack_public_path__ + "img/h-logo.20e8cce7.svg";